export const List = {
  V09: {
    name: "V09",
    price: "31.88",
    imgList: [
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/V09/v09_usp.webp",
        },
        desc: "了解 V09",
        url: "./usp-v09.html",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/V09/v09_vr.webp",
        },
        desc: "线上赏车",
        url: "https://www.hycan.com.cn/hycan-v09",
        blank: true,
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/V09/v09_test_drive.webp",
        },
        desc: "预约试驾",
        url: "./drive.html?type=V09",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/V09/v09_spec.webp",
        },
        desc: "查看配置表",
        url: "./params-table-config.html?type=V09",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/V09/v09_order.webp",
        },
        desc: "立即定购",
        url: "./optional.html?type=V09",
      },
    ],
  },
  A06: {
    name: "A06",
    price: "17.98",
    imgList: [
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/A06/a06_usp.webp",
        },
        desc: "了解 A06",
        url: "./usp-a06.html",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/A06/a06_vr.webp",
        },
        desc: "线上赏车",
        url: "https://www.hycan.com.cn/hycan-a06",
        blank: true,
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/A06/a06_test_drive.webp",
        },
        desc: "预约试驾",
        url: "./drive.html?type=A06",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/A06/a06_spec.webp",
        },
        desc: "查看配置表",
        url: "./params-table-config.html?type=A06",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/A06/a06_order.webp",
        },
        desc: "立即定购",
        url: "./optional.html?type=A06",
      },
    ],
  },
  Z03: {
    name: "Z03",
    price: "13.48",
    imgList: [
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/Z03/z03_usp.webp",
        },
        desc: "了解 Z03",
        url: "./usp-z03.html",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/Z03/z03_vr.webp",
        },
        desc: "线上赏车",
        url: "https://www.hycan.com.cn/hycan-z03",
        blank: true,
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/Z03/z03_test_drive.webp",
        },
        desc: "预约试驾",
        url: "./drive.html?type=Z03",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/Z03/z03_spec.webp",
        },
        desc: "查看配置表",
        url: "./params-table-config.html?type=Z03",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/Z03/z03_order.webp",
        },
        desc: "立即定购",
        url: "./optional.html?type=Z03",
      },
    ],
  },
  "007": {
    name: "007",
    price: "29.98",
    imgList: [
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/007/007_usp.webp",
        },
        desc: "了解 007",
        url: "./usp-007.html",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/007/007_vr.webp",
        },
        desc: "线上赏车",
        url: "https://www.hycan.com.cn/hycan-007",
        blank: true,
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/007/007_test_drive.webp",
        },
        desc: "预约试驾",
        url: "./drive.html?type=007",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/007/007_spec.webp",
        },
        desc: "查看配置表",
        url: "./params-table-config.html?type=007",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/007/007_order.webp",
        },
        desc: "立即定购",
        url: "./optional.html?type=007",
      },
    ],
  },
  A06PLUS: {
    name: "A06 PLUS",
    price: "13.98",
    imgList: [
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/A06PLUS/a06plus_usp.webp",
        },
        desc: "了解 A06 PLUS",
        url: "./usp-a06-plus.html",
      },
      // {
      //   img: {
      //     pc:
      //       "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/A06/a06_vr.webp",
      //   },
      //   desc: "线上赏车",
      //   url: "https://www.hycan.com.cn/hycan-a06",
      //   blank: true,
      // },
      // {
      //   img: {
      //     pc:
      //       "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/A06/a06_test_drive.webp",
      //   },
      //   desc: "预约试驾",
      //   url: "./drive.html?type=A06PLUS",
      // },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/A06PLUS/a06plus_spec.webp",
        },
        desc: "查看配置表",
        url: "./params-table-config.html?type=A06PLUS",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/A06PLUS/a06plus_order.webp",
        },
        desc: "立即定购",
        url: "./optional.html?type=A06PLUS",
      },
    ],
  },
  service: {
    imgList: [
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/Service/service_energy.webp",
        },
        desc: "能源服务",
        url: "./energy.html",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/Service/service_after_sales.webp",
        },
        desc: "售后服务",
        url: "./afterSale.html",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/Service/service_finance.webp",
        },
        desc: "金融服务",
        url: "./financial-solution.html",
      },
    ],
  },
  about: {
    imgList: [
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/About/about_hycan.webp",
        },
        desc: "关于合创",
        url: "./about.html",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/About/news.webp",
        },
        desc: "资讯中心",
        url: "./news.html",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/About/accessory.webp",
        },
        desc: "代理商招募",
        url: "./accessory.html",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/About/join_us.webp",
        },
        desc: "加入我们",
        url: "https://jobs.hycan.com.cn/",
      },
    ],
  },
};

export const menuList = {
  user: {
    title: "我的账号",
    list: [
      {
        label: "我的订单",
        url: "./test-order.html",
      },
      {
        label: "退出登录",
        type: "loginOut",
      },
    ],
  },
  language: {
    title: "选择语言",
    list: [
      {
        label: "中文",
        url: "./index.html",
      },
      {
        label: "English",
        url: "./en/index.html",
      },
    ],
  },
};
